import {Component, OnInit} from '@angular/core';
import {ConfiguratorI18nCacheService, SelectItem} from '@tj/tj-dmp-lib-api';
import {AbstractEditorComponent} from '../abstract-editor.component';
import {TranslateService} from '@ngx-translate/core';
import {ValueEditor} from '../value-editor';
import {FormBuilder} from '@angular/forms';
import {ValidatorEditorService} from '../validator-editor.service';

@Component({
    selector: 'dmp-country-editor',
    templateUrl: './country-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class CountryEditorComponent extends AbstractEditorComponent implements OnInit {
    items: SelectItem[] = [];

    constructor(protected translate: TranslateService,
                protected cacheI18n: ConfiguratorI18nCacheService,
                protected fb: FormBuilder,
                protected validatorService: ValidatorEditorService) {
        super(fb, validatorService);
    }
    transformBeforeSave(value: any) {
        return value.key;
    }

    ngOnInit(): void {
        this.init();
        this.originalValue = this.value;
        const initialValue = this.value;
        this.cacheI18n.searchUsingGET('COUNTRY', true).subscribe(res => {
            this.items = res.map(i => ({label: i.value, key: i.key} as SelectItem));
            if (initialValue && initialValue !== 'null') {
                const currentValue = this.items.find(i => i.key === initialValue);
                if (currentValue) {
                    this.formGroup.get('value').setValue(currentValue, {emitEvent: false});
                } else {
                    this.dataNotFound.next(this.field);
                }
            }
        });
    }
}
